import {STEP_GENERAL_INFORMATION, STEPS_JOURNEY} from "../public/journey1/definition/business";

const initialState = {
    loading:false,
  steps: STEPS_JOURNEY,
  currentStep:STEP_GENERAL_INFORMATION,
  isFirst:true,
  isLast:false

};

const isLast = (steps, currentStep) => {
  return steps.indexOf(currentStep) == (steps.length - 1);
}

const isFirst = (steps, currentStep) => {
  return steps.indexOf(currentStep) == 0;
}

export function saveStepper(state = initialState, action) {
    switch (action.type) {
      case 'SAVE.RESET_STEPS.SUCCESS':
        return {
          ...state,
          ...initialState,
        }
      case 'SAVE.SET_STEPS.SUCCESS':
          return {
            ...state,
            steps:action.params.steps
          }
        case 'SAVE.SET_NEXT_STEP.SUCCESS':
            var index = state.steps.indexOf(state.currentStep);
            var currentStep = index === -1  || index + 1 === state.steps.length ? null : state.steps[index+1];
            return {
                ...state,
                previousStep: state.currentStep,
                currentStep,
                isFirst:isFirst(state.steps, currentStep),
                isLast: isLast(state.steps, currentStep),

            };
        case 'SAVE.SET_PREVIOUS_STEP.SUCCESS':
          var index = state.steps.indexOf(state.currentStep);
          var currentStep = index === -1 || index - 1 < 0 ? null : state.steps[index-1];
          return {
            ...state,
            previousStep: state.currentStep,
            currentStep,
            isFirst:isFirst(state.steps, currentStep),
            isLast: isLast(state.steps, currentStep),
          };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/stepper.js